import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//首页
const Index = () => import('@/pages/home/index');
const Home = () => import('@/pages/home/home');
//找项目
const InvestIndex = () => import('@/pages/invest/index');
const Invest = () => import('@/pages/invest/invest');
const InvestDetail = () => import('@/pages/invest/detail');

//找跟投
const ShootIndex = () => import('@/pages/shoot/index');
const Shoot = () => import('@/pages/shoot/shoot');
const ShootDetail = () => import('@/pages/shoot/detail');

//领悬赏
const RewardIndex = () => import('@/pages/reward/index');
const Reward = () => import('@/pages/reward/reward');
const RewardDetail = () => import('@/pages/reward/detail');

//关于我们
const AboutUsIndex = () => import('@/pages/aboutUs/index');
const AboutUs = () => import('@/pages/aboutUs/aboutUs');

//个人中心
const PersonalIndex = () => import('@/pages/personal/index');
const Personal = () => import('@/pages/personal/personal');

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      redirect:'/home',
      children: [
        {
        path: '/home',
        name: "home",
        component: Home,
        }
      ]
    },
    {
      path: '/investIndex',
      name: 'investIndex',
      component: InvestIndex,
      redirect:'/invest',
      children: [
        {
        path: '/invest',
        name: "invest",
        component: Invest,
        },
        {
          path: '/investDetail',
          name: "investDetail",
          component: InvestDetail,
        },
      ]
    },
    {
      path: '/shootIndex',
      name: 'shootIndex',
      component: ShootIndex,
      redirect:'/shoot',
      children: [
        {
        path: '/shoot',
        name: "shoot",
        component: Shoot,
        },
        {
          path: '/shootDetail',
          name: "shootDetail",
          component: ShootDetail,
          },
      ]
    },
    {
      path: '/rewardIndex',
      name: 'rewardIndex',
      component: RewardIndex,
      redirect:'/reward',
      children: [
        {
        path: '/reward',
        name: "reward",
        component: Reward,
        },
        {
          path: '/rewardDetail',
          name: "rewardDetail",
          component: RewardDetail,
        }
      ]
    },
    {
      path: '/aboutUsIndex',
      name: 'aboutUsIndex',
      component: AboutUsIndex,
      redirect:'/aboutUs',
      children: [
        {
        path: '/aboutUs',
        name: "aboutUs",
        component: AboutUs,
        }
      ]
    },
    {
      path: '/personalIndex',
      name: 'personalIndex',
      component: PersonalIndex,
      redirect:'/personal',
      children: [
        {
        path: '/personal',
        name: "personal",
        component: Personal,
        }
      ]
    },
  ]
})
// router.beforeEach((to, from, next) => {
//   if (to.path === '/home') {
//     next();
//   } else {
//     let token = JSON.parse(localStorage.getItem('Token'));
//     if (token == null) {
//       next('/home');
//     } else {
//       next();
//     }
//   }
// });
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js